import { render, staticRenderFns } from "./GPSDevice.vue?vue&type=template&id=61088782&scoped=true&"
import script from "./GPSDevice.vue?vue&type=script&lang=js&"
export * from "./GPSDevice.vue?vue&type=script&lang=js&"
import style0 from "./GPSDevice.vue?vue&type=style&index=0&id=61088782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61088782",
  null
  
)

export default component.exports